<template>
  <div class="Judge_management">
    <div class="title pdlr20">
      <h2>
        <span class="back_btn" @click="$router.go(-1)">
          <i class="el-icon-arrow-left"></i>
        </span>作品管理
      </h2>
    </div>
    <div class="mt20" style="padding:0 30px 20px 30px;">
      <el-table
        border
        ref="multipleTable2"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChangeOpus"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="作品" width="200">
          <template slot-scope="scope">
            <div>
              <router-link
                target="_blank"
                :to="`/pro_detail?id=${scope.row.id}`"
                style="display:flex;align-items:center;"
              >
                <img style="width: 97px; height: 72px;object-fit:cover;" :src="scope.row.coverPath" />
                <div
                  style="
                font-size: 14px;color:#333;
                margin-left:20px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;"
                >{{scope.row.name}}</div>
              </router-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="school_name" label="学校（展会名称）"></el-table-column>
        <el-table-column prop="score" label="得分" width="120"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <div style="cursor:pointer;" class="color_blue" @click="judgesDialog(scope)">分配评委</div>
          </template>
        </el-table-column>
      </el-table>
      <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
      <div style="margin-top: 20px">
        <el-button type="primary" @click="moreProjudgesDialog">批量分配评委</el-button>
      </div>
    </div>
    <!-- 邀请评委 -->
    <el-dialog title="分配评委" :visible.sync="dialogVisible" width="750px" :destroy-on-close="true">
      <div class="multiple_box">
        <div class="multiple_tit">
          <el-input placeholder="请输入内容" v-model="name" style="width:336px;">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="getJudgesByCompetition"></i>
          </el-input>
        </div>
        <div class="multiple_content">
          <el-table
            border
            ref="multipleTable3"
            :data="tableData2"
            tooltip-effect="dark"
            style="width: 100%;"
            @select="selcectOne"
            @select-all="selcectAll"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name" label="评委姓名"></el-table-column>
            <el-table-column prop="company" label="单位"></el-table-column>
            <el-table-column prop="mobile" label="手机号"></el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <div style="cursor:pointer;" class="color_blue" @click="judgesDialog(scope)">分配评委</div>
              </template>
            </el-table-column>
          </el-table>
          <myPage :layerpageinfo="layerpageinfo2" @pageChange="changeJudgePage"></myPage>
        </div>
      </div>
      <div class="custom_footer">
        <div class="custom_footer_l">已选（{{judges.length}}）</div>
        <div class="custom_footer_c">
          <ul class="activeJuage">
            <li v-for="item in judges">
              {{item.name}}
              <i class="el-icon-close" @click="delateJudage(item)"></i>
            </li>
          </ul>
        </div>
        <div class="custom_footer_r">
          <el-button type="primary" @click="allotJudge">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import myTable from "@/components/my_table";
import myPage from "@/components/myPage/myPage";
export default {
  components: {
    myTable,
    myPage
  },
  data() {
    return {
      row: null, //临时操作对象
      dialogVisible: false,
      tableData: [], //作品列表
      tableData2: [], //评委列表
      judges: [], //评委ID数组
      opus: [], //作品ID
      name:'',
      layerpageinfo: {
        pageNo: 0,
        total: 0,
        pageSize: 10
      },
      layerpageinfo2: {
        pageNo: 0,
        total: 0,
        pageSize: 10
      }
    };
  },
  created() {
    this.initPage(); //初始页面
  },
  methods: {
    initPage() {
      this.getOpusByCompetition();
      this.getJudgesByCompetition();
      // this.initJudeges();//初始评委
    },
    // 单个操作
    selcectOne(sel, row) {
      // 如果是选中操作
      if (this.isSelect(sel, row)) {
        this.judges.push({
          name: row.name,
          id: row.id
        });
      } else {
        // 取消选中
        let judges = this.judges.filter(item => {
          return item.id !== row.id;
        });
        this.judges = judges;
      }
    },
    // 全部操作
    selcectAll(sel) {
      // 全选中
      if (sel.length) {
        this.tableData2.map(row => {
          this.judges.push({
            name: row.name,
            id: row.id
          });
        });
        this.judges = this.filterJson(this.judges, "id"); //去重
      } else {
        // 全部取消选中
        this.tableData2.map(row => {
          this.judges = this.judges.filter(item => {
            return item.id !== row.id;
          });
        });
      }
    },
    // 选中的作品
    handleSelectionChangeOpus(val) {
      this.opus = val;
    },
    // 选中的评委
    handleSelectionChangeJudges(arr) {
      console.log(arr);

      let newArr = [];
      arr.forEach(item => {
        this.judges.filter(it => {
          if (it.id !== item.id) {
            newArr.push({
              id: item.id,
              name: item.name
            });
          }
        });
      });
      this.judges = [...newArr, ...this.judges];
    },
    // 作品列表
    getOpusByCompetition() {
      let params = Object.assign({}, this.layerpageinfo, {
        competition: this.$route.query.competition
      });
      return new Promise(resolve => {
        this.api.getOpusByCompetition(params).then(res => {
          if (res.error.err_code !== 0) return;
          this.tableData = res.obj.list || [];
          this.layerpageinfo.total = res.obj.totalSize;
          resolve();
        });
      });
    },
    //  初始评委
    async initJudeges() {
      this.getJudgesByCompetition(); // 评委列表
      this.getOpusAllotJudges(); //查询作品已分配评委
    },
    // 所有已邀请评委列表
    getJudgesByCompetition() {
      let params = {
        competition: this.$route.query.competition,
        name:this.name || '',
        ...this.layerpageinfo2
      };
      return new Promise(resolve => {
        this.api.getJudgesByCompetition(params).then(res => {
          if (res.error.err_code !== 0) return;
          this.tableData2 = res.obj.list || [];
          this.layerpageinfo2.total = res.obj.totalSize;
          this.hasChecked(); //检查选中状态,翻页后需要重新检查
          resolve();
        });
      });
    },
    // 查询作品已分配评委
    getOpusAllotJudges() {
      let params = Object.assign({}, this.layerpageinfo2, {
        competition: this.$route.query.competition,
        opus: this.row.id
      });
      return new Promise(resolve => {
        this.api.getOpusAllotJudges(params).then(res => {
          if (res.error.err_code !== 0) return;
          let list = res.obj.list || [];
          this.judges = list.map(item => {
            return Object.assign(
              {},
              {
                id: item.judge,
                name: item.judge_name
              }
            );
          });
          this.hasChecked(); //评委列表已加载，需要检查选中状态
          resolve();
        });
      });
    },
    // 邀请评委
    allotJudge() {
      let judges = this.judges.map(item => {
        return item.id;
      });
      let opus = this.opus.map(item => {
        return item.id;
      });
      judges = judges.join(",");
      opus = opus.length ? opus.join(",") : this.row.id;
      let params = { judges, opus, competition: this.$route.query.competition };
      return new Promise(resolve => {
        this.api.allotJudge(params).then(res => {
          if (res.error.err_code !== 0) return;
          this.$message.success("分配成功!");
          this.dialogVisible = false;
          this.initPage();
          resolve();
        });
      });
    },
    // 点击分配评委（单个作品分配）
    judgesDialog(scope) {
      this.dialogVisible = true;
      this.row = scope.row;
      this.getOpusAllotJudges(); //查询作品已分配评委
    },
    // 点击分配评委（多个作品分配）
    moreProjudgesDialog() {
      this.dialogVisible = true;
      this.row = null;
      this.getOpusAllotJudges(); //查询作品已分配评委
    },
    // 删除评委
    delateJudage(item) {
      this.judges = this.judges.filter(it => {
        return item.id !== it.id;
      });
      this.tableData2.map(it => {
        if (it.id === item.id) {
          this.$refs.multipleTable3.toggleRowSelection(it, false);
        }
      });
    },
    // 评委列表切换
    changeJudgePage(pageNo) {
      this.layerpageinfo2.pageNo = pageNo;
      this.getJudgesByCompetition();
    },
    // 判断评委是否选中
    hasChecked() {
      let list = this.tableData2; //评委列表
      let judges = this.judges; //已选中评委列表
      let that = this;
      list.forEach(item => {
        judges.forEach(it => {
          if (item.id === it.id) {
            this.$nextTick(res => {
              that.$refs.multipleTable3.toggleRowSelection(item, true);
            });
          }
        });
      });
    },
    //当前点击操作是选中还是取消选中
    isSelect(sel, row) {
      let isTrue;
      // 已选中列表为空必定为取消选中
      if (!sel.length) {
        isTrue = false;
        return isTrue;
      }
      // 已选中列表sel中包含当前操作的对象为选中，反之为取消选中
      isTrue = sel.some(item => {
        return item.id === row.id;
      });
      return isTrue;
    },
    // json对象去重,根据指定字段
    filterJson(data, Name) {
      var dest = [];
      for (var i = 0; i < data.length; i++) {
        var ai = data[i];
        if (i == 0) {
          dest.push(ai);
        } else {
          var filterData = dest.filter(function(e) {
            return e[Name] == ai[Name];
          });
          if (filterData.length == 0) {
            dest.push(ai);
          }
        }
      }
      return dest;
    },
    // 作品列表切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getOpusByCompetition();
    }
  }
};
</script>

<style lang="scss">
.Judge_management {
  background: #fff;
  .title {
    padding: 20px 30px;
    h2 {
      display: flex;
      align-items: center;
      .back_btn {
        display: inline-block;
        width: 38px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border: 1px solid #dcdfe6;
        margin-right: 14px;
        cursor: pointer;
        vertical-align: top;
      }
    }
    border-bottom: 1px solid #eeeeee;
  }
  .title::before {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .multiple_box{
    padding:0 20px;
    .multiple_tit{
      padding: 10px 20px;
      background: #F8FAFD;
      border: 1px solid #ECF0F5;
      border-bottom: 0;
    }
    .multiple_content{

    }
  }
  .custom_footer {
    display: flex;
    background: #f8fafd;
    padding: 13px 20px;
    .custom_footer_l {
      padding: 6px 0;
    }
    .custom_footer_c {
      flex: 1;
      .activeJuage {
        display: flex;
        flex-wrap: wrap;
        li {
          font-size: 13px;
          color: #ff733c;
          margin: 0 16px 10px 0;
          padding: 6px;
          background: #fff;
          i {
            cursor: pointer;
          }
        }
      }
    }
    .custom_footer_r {
    }
  }
}
</style>